export default {
  menu: 'Contacts',
  title: 'Contacts',

  general: {
    labels: {
      user: 'person',
      name: 'First Name',
      family: 'Last Name',
      gender: 'Gender',
      phoneNumber: 'Mobile Number',
      company: 'company',
      deleteUser: 'Delete user',
      deleteCustomer: 'Delete Client',
      email: 'Email',
      description: 'Description',
      notHave: 'N/A',
      trn: 'TRN'
    },

    table: {
      header: {
        row: 'Row',
        select: 'Select',
        registryDate: 'Created Date',
        phoneNumber: 'Mobile',
        email: 'Email',
        creator: 'Creator',
        gender: 'Gender',
        name: 'Name',
        score: 'Point',
        group: 'Group',
        company: 'Company',
        accessGroup: 'Access',
        maxDebt: 'Credit',
        balance: 'Balance',
        address: 'Address',
        access: 'Access',
        status: 'Status',
        shops: 'Ecommerce',
        deleteAction: 'Delete',
        restoreAction: 'Restore'
      }
    },

    gender: {
      man: 'Mr.',
      woman: 'Mrs.',
      company: 'company'
    },

    types: {
      man: 'Mr.',
      woman: 'Mrs.',
      company: 'company'
    },

    characters: {
      shareholder: 'shareholder',
      employee: 'employee',
      intermediary: 'intermediary',
      supplier: 'Supplier',
      customer: 'client'
    },

    notifications: {
      insert: {
        success: 'Information successfully submitted',
        error: 'Insert user was associated with an error'
      },
      edit: {
        success: 'User information successfully updated',
        error: 'Error updating user information'
      },
      delete: {
        success: 'The person information was deleted',
        error: 'Deleting personal information was associated with an error'
      },
      restore: {
        success: 'The person information was restored',
        error: 'Restore personal information was associated with an error'
      },
      parseError: {
        phoneNumber: 'Phone number is exist in system'
      }
    },

    validators: {
      inputValuesIsWrong: 'The information entered is incorrect',
      company: 'Company name can not be more than 50 characters',
      name: 'Name can not be more than 30 characters',
      nameIsWrong: 'Name not entered correctly',
      nameCantEmpty: 'Name could not be empty',
      family: 'Last name can not be more than 50 characters',
      familyIsWrong: 'Last name not entered correctly',
      familyCantEmpty: 'Last name could not be empty',
      phoneNumber: 'Mobile Number format is incorrect',
      phoneNumberCantEmpty: 'Enter Mobile Number',
      email: 'Email could not exceed 50 characters',
      emailIsWrong: 'Email format is incorrect',
      requiredFieldIsEmpty: 'Required Fields are Missing',
      duplicatePhoneNumber: 'The Mobile Number entered in the system is available'
    },

    confirmations: {
      deleteFromUseral: {
        title: 'Confirm user deletion',
        body: 'Are you sure you want to delete {name} temporarily?'
      },
      deleteFromWoocommerce: {
        title: 'Confirmation',
        body: 'Are you sure you want to delete this customers information? If approved, the customer information will also be removed from your website! '
      },
      forceDelete: {
        title: 'Confirm user deletion',
        body: 'Are you sure you want to delete {userName} permanently?'
      }
    }
  },

  list: {
    title: 'Contacts',

    active: 'Active',
    customer: 'Client',
    presence: 'In shop'
  },

  trash: {
    title: 'Removed contacts'
  },

  select: {
    title: 'Contacts'
  },

  openingBalance: {
    general: {
      type: {
        debtor: 'debtors to the company',
        creditor: 'Creditors of the company'
      },

      labels: {
        importData: 'Upload user opening balance file'
      }
    },

    insert: {
      title: 'Add the first course {type}',

      notifications: {
        debtor: {
          success: {
            title: 'Message',
            message: 'Debtors first term successfully registered'
          },

          error: {
            title: 'error',
            message: 'Registration of the first information of the debtor users period was accompanied by Khaza'
          }
        },

        creditor: {
          success: {
            title: 'Message',
            message: 'The first period of creditors successfully registered'
          },

          error: {
            title: 'error',
            message: 'Registration of the first information period of creditor users was associated with Khaza'
          }
        },

        locked: {
          title: 'error',
          message: 'The opening balance is the lock'
        },

        importData: {
          success: 'User opening balance file successfully uploaded',
          error: 'Upload user opening balance has error'
        },

        isExists: {
          title: 'error',
          message: 'This value is in the list',
          dynamicMessage: 'There are {name} in the list'
        }
      }
    },

    edit: {
      title: 'First Edition {user}',

      labels: {
        price: 'Price',
        delete: 'Delete first course'
      },

      confirmations: {
        delete: {
          title: 'Delete Confirmation',
          body: 'Are you sure you want to delete the first person in the course?'
        }
      },

      notifications: {
        debtor: {
          update: {
            success: {
              title: 'Message',
              message: 'The opening balance of the debtor in question has been successfully updated'
            },

            error: {
              title: 'error',
              message: 'The first update of the debtors course was accompanied by an error'
            }
          },

          delete: {
            success: {
              title: 'Message',
              message: 'The opening balance of the desired debtor has been successfully deleted'
            },

            error: {
              title: 'error',
              message: 'The first deletion of the debtors course was accompanied by an error'
            }
          }
        },

        creditor: {
          update: {
            success: {
              title: 'Message',
              message: 'The opening balance of the creditor in question has been successfully updated'
            },

            error: {
              title: 'error',
              message: 'The first update of the creditors course was accompanied by an error'
            }
          },

          delete: {
            success: {
              title: 'Message',
              message: 'The first period of the creditor in question has been successfully deleted'
            },

            error: {
              title: 'error',
              message: 'The first deletion of the creditors course was accompanied by an error'
            }
          }
        }
      }
    },

    list: {
      table: {
        header: {
          delete: 'Delete',
          price: 'Amount',
          name: 'Name and surname',
          rowNumber: 'Row'
        }
      }
    }
  },

  insert: {
    title: 'Add contact',

    base: 'basic'
  },

  edit: {
    title: 'Edit Information',

    customer: 'client',

    dataCategory: {
      generalInfo: 'General Information',
      accessLevel: 'access level',
      advanceInfo: 'Advance Information',
      accessGroup: 'User Group'
    },

    woocommerce: {
      customerLogs: 'customer logs',

      description: {
        noLogExist: 'There are no logs for this client'
      }
    }
  },

  profile: {
    title: 'Profile',
    dynamicTitle: 'Profile',

    importantData: {
      phoneNumber: 'Phone number',
      balance: 'Balance',
      score: 'Point',
      email: 'Email',
      company: 'Company'
    },

    setMaxDebtModal: {
      title: 'Determining the maximum debt',
      label: 'Maximum personal debt',

      notifications: {
        success: {
          title: 'Message',
          message: 'Maximum debts successfully updated'
        },

        error: {
          title: 'error',
          message: 'Maximum debts update failed'
        }
      }
    },

    addressesModal: {
      title: 'Addresses'
    },

    transactionsModal: {
      title: 'Turnover'
    },

    actions: {
      call: 'Call',
      whatsApp: 'whatsApp',
      setUserMaxDebt: 'Credit Limit',
      points: 'Points',
      showUserAddresses: 'Address List',
      showUserTransactions: 'Transactions',
      insertSaleInvoice: 'Sale',
      insertPurchaseInvoice: 'Purchase',
      insertTreasuryReceive: 'Receive',
      insertTreasuryPayment: 'Payout',
      insertTreasuryCost: 'Cost',
      sendMessage: 'Send SMS',
      logs: 'Time lines'
    }
  },

  transactions: {
    title: 'Personal turnover',
    dynamicTitle: 'turnover',
    documentTitle: 'Personal Turnover Document',

    table: {

      header: {
        docNumber: 'Document Number',
        date: 'Date',
        documentation: 'Documents',
        price: 'Amount',
        balance: 'Inventory'
      }
    },

    types: {
      sale: 'Sale',
      purchase: 'Purchase',
      receive: 'Receive'
    }
  },

  points: {
    title: 'Contact Points',
    dynamicTitle: 'Point',
    documentTitle: 'User point Document',

    table: {

      header: {
        row: 'Row',
        date: 'Date',
        documentation: 'Documents',
        score: 'Point',
        total: 'Total'
      }
    },

    types: {
      sale: 'Sale',
      purchase: 'Purchase',
      receive: 'Receive'
    }
  },

  addresses: {
    title: 'Personal Addresses',
    dynamicTitle: 'Addresses',

    general: {
      notifications: {
        edit: {
          success: 'The address has been edited successfully',
          error: 'Edit address has error'
        },
        delete: {
          success: 'Address deleted successfully',
          error: 'Delete address has error'
        },

        parseError: {
          required: 'Required Fields are Missing'
        }
      }
    },

    insert: {
      title: 'Add new address',

      labels: {
        name: 'Address Title',
        country: 'Country',
        province: 'Province',
        city: 'City',
        address: 'Postal address',
        postalCode: 'postal code',
        receiver: {
          boxTitle: 'recipient information',
          name: 'Recipient',
          lastName: 'Recipient surname',
          phoneNumber: 'Caller ID'
        }
      },

      notifications: {
        incorrectDate: {
          title: 'Message',
          message: 'The information was not entered correctly'
        },

        success: {
          title: 'Message',
          message: 'New address successfully registered for user'
        },

        error: {
          title: 'error',
          message: 'Add users new address failed'
        },

        parseError: {
          required: 'Required Fields are Missing'
        }
      }
    },

    edit: {
      title: 'Edit contact address'
    },

    list: {

      notFountError: 'No Address registered!'
    },

    select: {

      table: {
        header: {
          receiverPhoneNumber: 'Recipient Mobile Number',
          receiverLastName: 'Recipient Last Name',
          receiverName: 'Recipient First Name',
          postalCode: 'Postcode',
          address: 'Address',
          city: 'City',
          province: 'Province',
          name: 'Title',
          select: 'Select'
        }
      }
    }
  },

  chat: {
    title: 'Contact chat',

    placeholder: {
      message: 'Write a message ...'
    },

    notifications: {
      send: {
        success: 'Message successfully send',
        error: 'Sending message has error'
      }
    },

    validators: {
      message: 'The message text was not entered correctly!'
    }
  },

  logs: {
    title: 'Personal Logs',

    table: {
      header: {
        rowNumber: 'Row',
        user: 'User',
        description: 'Description',
        date: 'Date'
      }
    },

    dialogs: {
      title: 'Descriptions',

      noChange: 'No field change'
    }
  }
}
